import { useIntl } from 'react-intl';
import { Platform, ScrollView, View } from 'react-native';

import { DraggableScrollView } from 'components/draggable-scrollview';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { UpsellSkeleton } from 'pages/cart/upsell/upsell.skeleton';
import { useAuthContext } from 'state/auth';

import { CartSectionHeader } from '../cart-section-header';
import { CartUpsellItem } from '../cart-upsell/cart-upsell-item';
import { useCartUpsellItems } from '../cart-upsell/use-cart-upsell-items';

const UpsellContent = () => {
  const { formatMessage } = useIntl();
  const upsellData = useCartUpsellItems();
  const isDesktop = useIsDesktopBreakpoint();
  const isDesktopWeb = isDesktop && Platform.OS === 'web';
  const ScrollViewComponent = isDesktopWeb ? DraggableScrollView : ScrollView;

  if (upsellData.loading) {
    return <UpsellSkeleton />;
  }
  if (!upsellData.items || upsellData.items.length === 0) {
    return null;
  }
  return (
    <View style={{ gap: 16, marginTop: 10 }} testID="upsell">
      <CartSectionHeader
        title={formatMessage({ id: 'addToOrderHeader' })}
        testID="cart-section-heading-label"
      />
      <ScrollViewComponent horizontal showsHorizontalScrollIndicator={false}>
        {upsellData.items.map(menuEntry => (
          <CartUpsellItem key={menuEntry.id} menuEntry={menuEntry} />
        ))}
      </ScrollViewComponent>
    </View>
  );
};

export const UpsellSection = () => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return null;
  }
  return <UpsellContent />;
};
